module.exports = __webpack_public_path__ + "img/Vectorright.a8a698ad.svg";